import CancelIcon from '@mui/icons-material/Cancel';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import React, { useRef, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { HorizontalContentDiv, ShowImage, UploadFile, UploadFileDiv } from './styledComponent';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Avatar } from '@mui/material';

function CustomUploadFile(props) {
	const {
		fileName,
		isFilePicked,
		setFileName,
		setIsFilePicked,
		setImageShow,
		imageShow,
		valueInputNo,
		profile,
		center
	} = props;

	// Create a reference to the hidden file input element
	const hiddenFileInput = useRef(null);
	// eslint-disable-next-line no-unused-vars
	const [fileError, setFileError] = useState(false);

	const showFile = async (e) => {
		e.preventDefault();
		const file = e.target.files[0];
		// console.log('mark1', e.target.files[0].name.length);

		const filesArray = Array.from(e.target.files).map((data) =>
			// eslint-disable-next-line implicit-arrow-linebreak
			URL.createObjectURL(data),
		);

		setImageShow((prevState) => prevState.concat(filesArray));
		Array.from(e.target.files).map(
			(data) => URL.revokeObjectURL(data), // avoid memory leak
		);

		setFileName(file);
		setIsFilePicked(true);
	};

	const handleClick = (operation) => {
		if (operation === 'select') {
			if (isFilePicked) {
				// console.log('already selected!');
			} else {
				hiddenFileInput.current.click();
			}
		} else if (operation === 'cancel') {
			// console.log('cancel', operation);
			// console.log('file value', document.getElementsByTagName('input')[3].value);
			document.getElementsByTagName('input')[valueInputNo].value = null;
			setFileName(null);
			setIsFilePicked(false);
			setFileError(false);
			setImageShow([]);
		}
	};

	const renderPhotos = imageShow && imageShow.map((photo, index) => ({ id: index, photo }));

	return (
		<UploadFileDiv center={center && center}>
			{/*  our custom upload button --> */}
			<UploadFile htmlFor='actual-btn' onClick={() => handleClick('select')}>

				{profile ?
					<>
						{renderPhotos.length > 0 ?
							<Avatar sx={{ width: 56, height: 56 }} alt="spec_icon" src={renderPhotos[renderPhotos.length - 1]?.photo} />
							: <AccountCircleIcon style={{ fontSize: '50px' }} />
						}
					</>
					:
					<HorizontalContentDiv>
						<PhotoCamera style={{ marginRight: '1rem' }} />
						<div>
							{!isFilePicked
								? 'Choose File'
								: fileName && fileName?.name.length > 20
									? `${fileName?.name.slice(0, 8)}...${fileName?.name.slice(
										fileName.name.length - 8,
										fileName.name.length,
									)}`
									: fileName?.name}
						</div>
					</HorizontalContentDiv>
				}

				{isFilePicked && (
					<div aria-hidden='true' onClick={() => handleClick('cancel')}>
						<CancelIcon
							fontSize='small'
							style={{ marginTop: '0.2rem', marginRight: '-0.3rem' }}
						/>
					</div>
				)}
			</UploadFile>



			{renderPhotos && !profile && (
				<ShowImage>
					{renderPhotos.length > 0 && (
						<img
							src={renderPhotos[renderPhotos.length - 1]?.photo}
							alt='spec_icon'
							height='90'
						/>
					)}
				</ShowImage>
			)}

			<input
				id='upload-file'
				type='file'
				accept='image/*'
				ref={hiddenFileInput}
				onChange={showFile}
				style={{ display: 'none' }}
			/>
			{/* </form> */}
		</UploadFileDiv>
	);
}

export default CustomUploadFile;
